// extracted by mini-css-extract-plugin
export default {"container":"DetailItem__container___EBhgh","vertical":"DetailItem__vertical___a1HRB","label":"DetailItem__label____fR7G"};